// SocialLoginButton.jsx
import React from 'react';

export default function SocialLoginButton({ label, redirectUrl, onRedirect, style }) {
  const handleRedirect = () => {
    if (onRedirect) {
      onRedirect();
    } else if (redirectUrl) {
      window.location.href = redirectUrl;
    }
  };

  return (
    <button
      type="button"
      onClick={handleRedirect}
      className="btn btn-light btn-block d-flex align-items-center justify-content-center"
      style={{
        border: "1px solid #ccc",
        borderRadius: "6px",
        padding: "10px",
        fontWeight: 500,
        backgroundColor: "#fff",
        color: "#000",
        fontSize: "14px",
        ...style,
      }}
    >
      {/* Ícone da Microsoft embutido */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 23 23"
        style={{ width: 20, height: 20, marginRight: 8 }}
      >
        <rect width="10.5" height="10.5" x="1" y="1" fill="#f35325" />
        <rect width="10.5" height="10.5" x="11.5" y="1" fill="#81bc06" />
        <rect width="10.5" height="10.5" x="1" y="11.5" fill="#05a6f0" />
        <rect width="10.5" height="10.5" x="11.5" y="11.5" fill="#ffba08" />
      </svg>

      <span>{label}</span>
    </button>
  );
}
